module.exports = new __parcel__URL__("pacman-death.1610ead1.mp3").toString();